"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logMethodBegin = logMethodBegin;
exports.logMethodEnd = logMethodEnd;
exports.logMethodEndInputAndOutput = logMethodEndInputAndOutput;
exports.log = log;
exports.determineLoggingLevel = determineLoggingLevel;
exports.logScriptLoad = logScriptLoad;
const core_common_1 = require("./core-common");
function logMethodBegin(method) {
    log("Begin.", 4 /* LogType.Debug */, method, true);
}
function logMethodEnd(method, result) {
    log(`End. Returning: ${result !== null && result !== void 0 ? result : "n/a"}`, 4 /* LogType.Debug */, method, true);
}
function logMethodEndInputAndOutput(method, input, result) {
    log(`End. Input: "${input}", returning: "${result !== null && result !== void 0 ? result : "n/a"}"`, 4 /* LogType.Debug */, method, true);
}
function log(message, logType, caller, prependWithTimestamp) {
    if (!logType) {
        // if caller didnt provide a log type for the message, assume its "info".
        logType = 3 /* LogType.Information */;
    }
    if (message) {
        let loggingLevel = determineLoggingLevel();
        if (loggingLevel >= logType) {
            if (caller) {
                message = "[ " + caller + " ] => " + message;
            }
            if (prependWithTimestamp) {
                message = `${(0, core_common_1.getTime)()}: ${message}`;
            }
            switch (loggingLevel) {
                case 4 /* LogType.Debug */:
                    console.log(message);
                    break;
                case 3 /* LogType.Information */:
                    console.info(message);
                    break;
                case 2 /* LogType.Warning */:
                    console.warn(message);
                    break;
                case 1 /* LogType.Error */:
                default:
                    console.error(message);
            }
        }
    }
}
;
function determineLoggingLevel() {
    let clientLoggingLevel = $("#LogType");
    if (clientLoggingLevel.length > 0) {
        return Number($(clientLoggingLevel[0]).val());
    }
    else {
        return 0 /* LogType.None */;
    }
}
;
function logScriptLoad(scriptId) {
    if (scriptId) {
        console.log("Loaded script: " + scriptId);
    }
}
;
